import React, { useState, useEffect ,useRef} from "react";
import './ResumeGuruPage.css';
import ResumeModal from "./ResumeModal";
import useAuthService from '../../services/AuthService';
import ResumePreview from './ResumePreview';
import { useAuthContext } from "../Auth/AuthContext";
import config from "../../config.json";
import Notification from "./Notification";
import { useNavigate } from "react-router-dom";
import { Sparkles,Plus,ChevronDown, LockKeyhole } from "lucide-react";



const ResumeGuruPage = () => {

    const [resumeModal, setresumeModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedResume, setSelectedResume] = useState(null);
    const navigate = useNavigate();
    const [showPreview, setShowPreview] = useState(false);
    const { userObjId,userAnalytics,setUserAnalytics,resumes, setResumes} = useAuthContext(); // Get userObjId and newUser from context
    const [showNotification, setShowNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');

    const generateResume_ID=()=>{
        let ID= `Resume ${(resumes!=null && resumes.length+1<10) ? `0${resumes.length+1}` : resumes.length+1}`;
        return ID;
    }


    const fetchAnalyticsDetails = async () => {
        try {
            setUserAnalytics({})
            const response = await fetch(`${config.restAPI}/sessions/getuserAnalytics/`, {
                method: "POST",
                credentials:"include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ user_obj_id:userObjId }),
            });

            if (!response.ok) {
                throw new Error("Failed to fetch profile details");
            }
            const data = await response.json();
            setUserAnalytics(data);
        } catch (error) {
            console.error("Error fetching profile details:", error);
        }
    };

    const fetchResumes = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${config.restAPI}/resume/getResumes/`, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_obj_id: userObjId,
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch resumes. Status: ${response.status}`);
            }

            const data = await response.json();
            const sortedResumes = data.resumes.sort((a, b) => {
                const aDate = new Date(a.created_at);
                const bDate = new Date(b.created_at);
                return bDate - aDate; // Latest first (descending order)
            });
    
            setResumes(sortedResumes || []); 
        } catch (error) {
            console.error("Error fetching resumes:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {           
            fetchResumes();
    }, []);

    const [showDropDown, setShowDropDown]= useState(false);
    const dropdownRef=useRef(null);
    const buttonRef= useRef(null);
    useEffect(() => {
        const handleOutsideClick = (event) => {
          // If click is outside the button and dropdown, close the dropdown.
          if (
            dropdownRef.current && !dropdownRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)
          ) {
            setShowDropDown(false);
          }
        };
    
        if (showDropDown) {
          document.addEventListener('mousedown', handleOutsideClick);
        }
        //  else {
        //   document.removeEventListener('mousedown', handleOutsideClick);
        // }
        return () => {
          document.removeEventListener('mousedown', handleOutsideClick);
        };
      }, [showDropDown]);

    const handleViewResume = (resumeData) => {
        const formattedResume = {
            message: {
                first_name: resumeData.resume.personalDetails.firstName,
                last_name: resumeData.resume.personalDetails.lastName,
                email: resumeData.resume.personalDetails.email,
                phone_number: resumeData.resume.personalDetails.phoneNumber,
                linkedin_url: resumeData.resume.personalDetails.linkedIn,
                website_url: resumeData.resume.personalDetails.website,
                professional_summary: resumeData.resume.personalDetails.summary,
                skills: resumeData.resume.skills,
                experience: resumeData.resume.experiences.map(exp => ({
                    job_role: exp.jobTitle,
                    company_name: exp.companyName,
                    start_date: exp.startDate,
                    end_date: exp.endDate,
                    responsibilities: exp.description ? exp.description.split('\n') : [],
                    city_state: exp.location,
                    country: exp.country,
                    skills: exp.skills || [],
                    domain: exp.domain
                })),
                education: resumeData.resume.education.map(edu => ({
                    school_university: edu.school,
                    degree: edu.degree,
                    start_date: edu.startDate,
                    end_date: edu.endDate,
                    gpa: edu.gpa,
                    city_state: edu.city_state,
                    country: edu.country,
                    additionalDetails: edu.additionalDetails
                }))
            }
        };
        setSelectedResume(formattedResume);
        setShowPreview(true);
    };
    

    const handleEditResume = (_id) => {
        // Find the resume with the given _id
        const selected = resumes.find(resumeData => resumeData._id === _id);
        if (!selected) {
            console.error(`Resume with id ${_id} not found`);
            return;
        }
        // Format the data as needed for ResumeModal
        const formattedResume = {
            message: {
                first_name: selected.resume.personalDetails.firstName,
                res_obj_id: _id,
                resumeId: selected.resume_id,
                last_name: selected.resume.personalDetails.lastName,
                email: selected.resume.personalDetails.email,
                phone_number: selected.resume.personalDetails.phoneNumber,
                linkedin_url: selected.resume.personalDetails.linkedIn,
                website_url: selected.resume.personalDetails.website,
                professional_summary: selected.resume.personalDetails.summary,
                skills: selected.resume.skills,
                experience: selected.resume.experiences.map(exp => ({
                    job_role: exp.jobTitle,
                    company_name: exp.companyName,
                    start_date: exp.startDate,
                    end_date: exp.endDate,
                    responsibilities: exp.description ? exp.description.split('\n') : [],
                    city_state: exp.location,
                    country: exp.country,
                    skills: exp.skills || [],
                    domain: exp.domain
                })),
                education: selected.resume.education.map(edu => ({
                    school_university: edu.school,
                    degree: edu.degree,
                    start_date: edu.startDate,
                    end_date: edu.endDate,
                    gpa: edu.gpa,
                    city_state: edu.city_state,
                    country: edu.country,
                    additionalDetails: edu.additionalDetails
                }))
            }
        };
    
        setSelectedResume(formattedResume);
        setresumeModal(true);
    };
    

const authService = useAuthService();
    const websocketUrlForFileUpload = "wss://jvplqszjpi.execute-api.us-west-2.amazonaws.com/production/"; // WebSocket for File upload

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.error("No file selected.");
      return;
    }
    handleFileUpload(file);
    event.target.value = null; // Clear the input after handling
  };

  const handleFileUpload = (file) => {
    setLoading(true);
    setresumeModal(true);
    setShowDropDown(false);
    const websocketInstance = new WebSocket(websocketUrlForFileUpload);

    websocketInstance.onopen = () => {
      const message = { action: "botguru_sendmessage", message: "get data" };
      sendWebSocketMessageWithRetry(websocketInstance, message);
    };

    websocketInstance.onmessage = (event) => handleWebSocketMessage(event, file);

    websocketInstance.onerror = (error) => {
      console.error("WebSocket error for Resume Upload:", error);
    };

    websocketInstance.onclose = () => {
    //   console.log("WebSocket connection closed for Resume Upload.");
    };
  };

  const handleWebSocketMessage = async (event, file) => {
    if (!event.data || event.data.trim() === "") {
        console.warn("Empty WebSocket message received.");
        return;
    }

    try {
        const data = JSON.parse(event.data);
        setLoading(true);
        
        if (data.connectionid) {
            // Step 1: Call authService to extract resume data
            const response = await authService
                .resumeExtractor({
                    file,
                    connectionId: data.connectionid,
                    user_obj_id: userObjId,
                });

        } else if (data.message) {

            const experienceSkills = (data.message.experience || [])
            .flatMap(exp => exp.skills || []) // Extract skills from each experience
            .filter((skill, index, self) => self.indexOf(skill) === index); // Remove duplicates
            // Step 2: Full resume data received
            const formattedResume = {
              message: {
                  first_name: data.message.first_name || '',
                  last_name: data.message.last_name || '',
                  email: data.message.email || '',
                  phone_number: data.message.phone_number || '',
                  linkedin_url: data.message.linkedin_url || '',
                  website_url: data.message.website_url || '',
                  professional_summary: data.message.professional_summary || '',
                  skills: [...new Set([...(data.message.skills || []), ...experienceSkills])], // Merge extracted skills
                  experience: data.message.experience || [],
                  education: data.message.education || []
              }
          };

          setSelectedResume(formattedResume); // Set the formatted data
          setLoading(false);
          setresumeModal(true);
        }
    } catch (error) {
        console.error("Error handling WebSocket message:", error);
        setNotificationMessage(error?.data.error);
        setShowNotification(true);
        setLoading(false);
        setresumeModal(false);
    }
};

  const sendWebSocketMessageWithRetry = (websocketInstance, message, retries = 3, interval = 1000) => {
    let attempts = 0;

    const sendMessage = () => {
      if (websocketInstance.readyState === WebSocket.OPEN) {
        websocketInstance.send(JSON.stringify(message));
      } else if (attempts < retries) {
        attempts++;
        setTimeout(sendMessage, interval);
      } else {
        console.error("Failed to send WebSocket message after multiple attempts.");
      }
    };
    sendMessage();
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    if (dateStr === 'Present') return new Date();
    
    const [month, year] = dateStr.split(' ');
    const monthIndex = new Date(Date.parse(month + " 1, 2000")).getMonth();
    return new Date(parseInt(year), monthIndex);
};

const calculateTotalExperience = (experiences) => {
    if (!experiences || experiences.length === 0) return 'No experience';

    let totalMonths = 0;
    
    experiences.forEach(exp => {
        const startDate = parseDate(exp.startDate);
        const endDate = exp.endDate === 'Present' ? new Date() : parseDate(exp.endDate);
        
        if (startDate && endDate) {
            const months = (endDate.getFullYear() - startDate.getFullYear()) * 12 + 
                          (endDate.getMonth() - startDate.getMonth());
            totalMonths += months;
        }
    });

    const years = Math.round(totalMonths / 12); // Round to nearest year
    return `${years}+ years`;
};


const closeresumeModal = () => setresumeModal(false);


const fileInputRef = useRef(null);
const handleUploadResumeClick = () => {

    if (fileInputRef.current) {
        fileInputRef.current.click();
    } else {
        console.error("File input field not found.");
    }
    
};

const handleNewResumeClick = () => {
        setSelectedResume(null);
        setresumeModal(true);
};

    // Calculate the total sessions available by summing prepbot and mock_bot totals
    const totalSessions = (userAnalytics?.total_resume_extractor || 0)
    const usedSessions = (userAnalytics?.used_resume_extractor || 0)

    // Determine if the user has available sessions
    const hasSessions = totalSessions > usedSessions;

    return (
        <>
            <div className="resume-guru-page">
                <div className="hero-section">
                    <div className="hero-content">
                        <div className="hero-left">
                            <h1 className="hero-title">
                                Your Personalized Resume Bot
                            </h1>
                            <div className="hero-description">
                                <span>Create professional resumes in minutes! Use our AI-powered platform to customize templates and highlight your skills. Generate standout resumes with perfect formatting and ensure success using ResumeBot!</span>
                            </div>
                        </div>
                    </div>
                </div>
                <input
                    ref={fileInputRef} 
                    type="file"
                    accept=".docx,.pdf"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    />
                <div className="job-upload-create-btn-container"
                >
                    <button className="job-upload-create-btn" ref={buttonRef} 
                    onClick={()=>setShowDropDown(true)} 
                    onMouseEnter={() => setShowDropDown(true)} 
                    onMouseLeave={() => {
                        setTimeout(() => {
                            if (!dropdownRef.current?.matches(':hover')) {
                                setShowDropDown(false);
                            }
                        }, 100);
                    }}
                    >
                        <Plus className="btn-icon" />
                        <span>Add New Resume</span>
                        <ChevronDown className={`drop-down-icon ${showDropDown ? "active" : ""}`} /> 
                    </button>

                    {
                    showDropDown && 
                    (
                        <div className="resume-drop-down-container" ref={dropdownRef}  onMouseEnter={() => setShowDropDown(true)}
                        onMouseLeave={() => setShowDropDown(false)}   onClick={()=>setShowDropDown(false)} >
                            <div className="job-upload-create-cards">
                                <div className="drop-down-option"
                                 onClick={() => {
                                    if (hasSessions) {
                                        handleUploadResumeClick()
                                    } else {
                                        navigate("/pricing", { state: { activeTabName: 'Expert Resume Builder' } })
                                    }
                                }}
                                 >
                                    {hasSessions?(
                                    <>
                                    <div className="upload-jd-option">
                                        <i className="fas fa-cloud-upload-alt"></i> Upload Resume
                                    </div>
                                    </>
                                    ) : (
                                        <>
                                        <div className="upload-jd-access">
                                            <div className="upload-jd-option">
                                            <i className="fas fa-cloud-upload-alt"></i>
                                            Upload Resume
                                            </div>
                                            <i className="fas fa-lock"></i>
                                         </div>
                                        </>
                                )}
                                </div>
                                <div className="drop-down-option" onClick={handleNewResumeClick}>
                                    <i className="fas fa-file-alt"></i> Create Resume
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="resume-cards-container">
                {loading ? null : (
                    resumes.length === 0 ? (
                    <div className="no-session-box">
                        <div className="no-session-content">
                            <Sparkles color='#BE05FA'/>
                            <h3>No Resumes</h3>
                            <p>Start creating a new resume.</p>
                        </div>
                    </div>
                ) : (
                    resumes.map((resumeData) => {
                         const resume = resumeData.resume; 
                         return (
                        <div className="resume-card" key={resumeData._id}>
                            <div className="jd-card-details">
                            <div className="jd-heading">
                                <div className="jd-title">
                                    <h3>{resume.experiences?.[0]?.jobTitle || 'No Job Title'}</h3>
                                        <span className="jd-id-badge">
                                        <span className="jd-id-number">{resumeData.resume_id}</span>
                                        </span>    
                                </div>
                                <div className="info-row">
                                    <div className="info-item">
                                        {/* <span className="info-label">Last Updated</span> */}
                                        <div className="info-value">
                                            <i className="far fa-clock"></i>
                                            {new Date(resumeData.last_updated).toLocaleDateString('en-US', { day:'numeric',year: 'numeric', month: 'short' })}
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        {/* <span className="info-label">Experience</span> */}
                                        <div className="info-value">
                                            <i className="fas fa-briefcase"></i>
                                            {calculateTotalExperience(resume.experiences)}
                                        </div>
                                    </div>
                                    <div className="skills-section">
                                    {/* <span className="skills-label">Key Skills</span> */}
                                    <div className="skills-list">
                                    <i className="fas fa-code company-icon"></i>
                                    {resume.skills && resume.skills.length > 0 ? (
                                        resume.skills.slice(0, 4).map((skill, index) => (
                                            <span key={index} className="skill-tag">
                                                {skill}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="info-value">Skills not provided</span>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="jd-action">
                            <span className="jd-file-type" onClick={(e) =>  handleEditResume(resumeData._id)}>
                                <i className="fas fa-pen  view-icon"></i>
                            </span>
                            <span className="jd-file-type"  onClick={(e) => handleViewResume(resumeData)}>
                                    <i className="fas fa-chevron-right view-icon"  ></i>
                            </span>
                        </div>
                           
                        </div>
                           
                        </div>
                         );
                    })
                )
                )}
                </div>

                {resumeModal && (
                    <ResumeModal 
                        isOpen={resumeModal} 
                        resumeData={selectedResume} 
                        closeModal={closeresumeModal} 
                        onResumeSubmit={() => {
                            setresumeModal(false);
                            fetchResumes();
                            fetchAnalyticsDetails();

                        }}
                        isLoading={loading}

                    />
                )}
                
                {showPreview && (
                    <ResumePreview 
                        resumeData={selectedResume}
                        closeModal={() => setShowPreview(false)}
                    />
                )}
                 {showNotification && (
                <Notification 
                    message={notificationMessage}
                    onClose={() => setShowNotification(false)}
                />
            )}
            </div>
        </>
    );
};

export default ResumeGuruPage;
